module.exports = __webpack_public_path__ + "static/media/bubble_reecall_2020_white_bordered.c68344d6.svg";